import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Dayjs } from "dayjs";

import { type Order } from "@fitness-app/data-models/entities/Order";

import { type AsyncThunkCreator } from "../../../index";
import { PRODUCT_ORDERS_REDUCER_NAME, type OrderWithRelations } from "../types";

type Payload = {
  productId: string;
  selectedMonth: Dayjs;
  ownerId?: string;
};

type OrderWithJoins = Order & {
  checkoutVariant: { slug: string } | null;
  salesFunnelRelation: { name: string; slug: string } | null;
};

export const fetchOrders = createAsyncThunk<OrderWithRelations[], Payload, AsyncThunkCreator<string>>(
  `${PRODUCT_ORDERS_REDUCER_NAME}/fetchOrders`,
  async ({ productId, selectedMonth }, { rejectWithValue, extra: { db } }) => {
    const { error, data } = await db
      .from("product_order")
      .select("*, checkoutVariant:checkout_variant(slug), salesFunnelRelation:sales_funnel(name, slug)")
      .order("createdAt", { ascending: false })
      .eq("product", productId)
      .gte("createdAt", selectedMonth.startOf("month").toISOString())
      .lte("createdAt", selectedMonth.endOf("month").toISOString())
      .returns<OrderWithJoins[]>();

    if (error) {
      return rejectWithValue(error.message);
    }

    return data.map(({ checkoutVariant, salesFunnelRelation, ...order }) => ({
      ...order,
      checkoutVariantSlug: checkoutVariant?.slug ?? null,
      salesFunnelName: salesFunnelRelation?.name || salesFunnelRelation?.slug || null,
    }));
  },
);
